import React, { useContext } from 'react';
import useJobTitleService from '../../../app/services/hooks/useJobTitleService';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    JobTitleId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const JobTitleSwitchChange = ({ JobTitleId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeJobTitle, fetchingActiveJobTitle } = useJobTitleService();

    const active = (value: boolean) => {
        setChecked(value);

        activeJobTitle(JobTitleId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={JobTitleId} callback={active} />;
};

export default JobTitleSwitchChange;
